import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import PanelContainer from './PanelContainer';
import './AdminDashboard.css';

export default function AdminDashboard() {
    return (
        <div className="admin-dashboard">
            <AdminSidebar />
            <div className="admin-main">
                <AdminHeader />
                <PanelContainer />
            </div>
        </div>
    );
}
